export default __webpack_public_path__ + "static/media/a023-startup4-en.509ce90f.png";